/**
 * @copyright Copyright (c) 2020, KNE GmbH.
 *
 * @author Jan Duwe <jan.duwe@kne.de>
 *
 * @license AGPL-3.0
 *
 * This code is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License, version 3,
 * as published by the Free Software Foundation.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License, version 3,
 * along with this program.  If not, see <http://www.gnu.org/licenses/>
 *
 */

import { GetterTree } from "vuex";
import { IRootState } from "../../model/RootState";
import { IUserState } from "../../model/UserState";

export const getters: GetterTree<IUserState, IRootState> = {
    getLogedinStatus (state: IUserState) {
        if (state.accessToken !== '') {

            const token = state.accessToken.split('.')[1] || "";
            const info = JSON.parse(window.atob(token));
            const notValidBefor = info.nbf;
            const expires = info.exp;

            const currentTime = Math.floor(new Date().getTime() / 1000)

            if(currentTime < notValidBefor || currentTime > expires){
                console.error("JWT not valid")

                return false;
            }

            return true;
        }
        return false
    },

    getDecodedAuthToken (state: IUserState, getters: any) {
        if (getters.getLogedinStatus) {
            const token = state.accessToken.split('.')[1] || "";
            return JSON.parse(window.atob(token))
        }
        return {}
    },

    getUserRole (state: IUserState, getters: any) {
        if (getters.getLogedinStatus) {
            const token = state.accessToken.split('.')[1] || "";
            const info = JSON.parse(window.atob(token))
            return info.role
        }
        return 'none'
    },

    isUserAdmin (state: IUserState, getters: any) {
        if (getters.getLogedinStatus) {
            const token = state.accessToken.split('.')[1] || "";
            const info = JSON.parse(window.atob(token))
            if (info.role === 'Admin') {
                return true
            } else {
                return false
            }
        } else {
            return false
        }
    },


};